import {gsap} from 'gsap'
import {Cloner} from '@js/utils/Cloner'

export class Archive {
  constructor() {

    this.container = document.querySelector('*[data-archive]')
    if (!this.container) {
      return
    }

    this.type = this.container.getAttribute('data-archive')

    this.functionnalities = {
      filter: !!this.container.getAttribute('data-filters'),
      pagination: !!this.container.getAttribute('data-pagination')
    }

    if (this.functionnalities.filter) {
      this.filters_container = this.container.querySelector('*[data-filters]')
      this.filters_type = this.filters_container.getAttribute('data-filters')
      this.filters = this.filters_container.querySelectorAll('*[data-filter]')
    }

    if (this.functionnalities.pagination) {
      this.pagination = this.paginationDefaults()
      this.moreBtn = this.container.querySelector('*[data-archive-btn-more]');
    }

    this.itemsContainer = this.container.querySelector('*[data-archive-endpoint]')
    this.loader = this.container.querySelector('.loader')

    this.baseUrl = `${window.location.protocol}//${window.location.hostname}`
    this.port = window.location.port ? `:${window.location.port}` : '';
    this.url = `${this.baseUrl}${this.port}/wp-json/akyos/v1/${this.type}`
    this.currentTax = ''

    this.register()
  }

  paginationDefaults() {
    return {
      items_per_page: parseInt(this.container.getAttribute('data-itemsperpage')),
      current_page: 1,
      max_pages: parseInt(this.container.getAttribute('data-maxpages')),
    }
  }

  resetFilters() {
    this.filters.forEach(f => f.classList.remove('active'))
    this.itemsContainer.innerHTML = ''
  }

  resetPagination() {
    this.pagination = this.paginationDefaults()
    this.moreBtn.setAttribute('hidden', '')
  }

  register() {

    if (this.functionnalities.filter) {
      this.filters.forEach(f => {
        f.addEventListener('click', (e) => {
          const id = f.dataset.filter
          e.preventDefault()
          this.resetFilters()
          if (this.functionnalities.pagination) {
            this.resetPagination()
          }
          f.classList.add('active')
          this.currentTax = id
          this.fetch(true)
        })
      })
    }

    if (this.functionnalities.pagination) {
      this.moreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.pagination.current_page += 1;
        if (this.pagination.current_page === this.pagination.max_pages) {
          this.moreBtn.setAttribute('hidden', '')
        }
        this.fetch();
      })
    }


  }

  fetch(reset = false) {

    this.loader.removeAttribute('hidden')

    const params = new URLSearchParams()

    if (this.functionnalities.filter) {
      if (this.currentTax && this.currentTax !== '*') {
        params.append(this.filters_type, this.currentTax)
      }
    }

    if (this.functionnalities.pagination) {
      params.append('per_page', this.pagination.items_per_page)
      params.append('page', this.pagination.current_page)
    }

    fetch(`${this.url}?${params.toString()}`)
      .then((r) => r.json())
      .then(r => {

        if (reset) {
          this.itemsContainer.innerHTML = ''
          if(this.functionnalities.pagination) {
            this.pagination.max_pages = r.max_pages
            if (this.pagination.max_pages > 1) {
              this.moreBtn.removeAttribute('hidden')
            }
          }
        }

        if (r.posts.length === 0) {
          this.itemsContainer.innerHTML = '<p id="no-result">Aucun résultat trouvé</p>'
        } else {
          this.appendItems(r.posts)
        }

        this.loader.setAttribute('hidden', '')

      })
      .catch(r => {
        console.log(r)
      })
  }

  appendItems(items) {

    const template = document.querySelector('#archive-el')

    items.forEach((item) => {
      let clone = template.content.cloneNode(true)
      clone = new Cloner(this.type, clone, item)
      this.itemsContainer.appendChild(clone.post)
    })

  }

}

